import { render, staticRenderFns } from "./IresDeviceDetailContentSelector.vue?vue&type=template&id=38777b6f&scoped=true&"
import script from "./IresDeviceDetailContentSelector.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceDetailContentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceDetailContentSelector.vue?vue&type=style&index=0&id=38777b6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38777b6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
